import React from 'react';
import Logo from '../images/logo2.svg';
import Image from './Image';
import Social from './smallComponent/Social';
import Button from './Button';
import Links from './smallComponent/Links';
import '../style/footer.css';

export default function Footer(){
    return(
        <div className="foot">
         <div className="left">
         <div className="left1">
             <Image className="footImage" src={Logo}/>
          </div>
          <div className="right1">
            <Social />
          </div>
         </div>

         <div className="middle">
          <div className="left2">
          <Links value="About"/>
          <Links value="Contact"/>
          <Links value="Blog"/>
          </div>
          <div className="right2">
          <Links value="Careers"/>
          <Links value="Support"/>
          <Links value="Private Policy"/>
          </div>
         </div>

         <div className="right">
         <Button type="submit" value="Require Invite"/>
         <p>© EasyBank All Rights Reserved 2022</p>
         </div>
        </div>
    )
}